import React from 'react'
import Header from "components/Headers/Header.js";
import { useState, useEffect } from "react";
import axios from 'axios'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, CardFooter, Button, Alert, CardTitle} from "reactstrap";
import { Form } from 'react-bootstrap';
import { format } from 'date-fns'; 
import { MapContainer, TileLayer, LayersControl, FeatureGroup, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {Link} from 'react-router-dom'

function MobilePhoneInsurance() {
  
  const [loading, setLoading] = useState(true)
  const [loadingsubmitrastermap, setLoadingsubmitrastermap]=useState(true)

  const [error, setError]=useState(false)
  const [message, setMessage]=useState('')

  const [dateoptions, setDateoptions] = useState([]);
  const [date, setDate] = useState('');

  const [variable, setVariable] = useState("count")

  const [sensordata, setSensordata]=useState([])

  const [loadingsubmit, setLoadingsubmit] = useState(true)
  const [htmlmap, setHtmlmap]=useState('')
  const [htmlgraph, setHtmlgraph]=useState('')

  const [max, setMax] = useState('')
  const [mean, setMean] = useState('')
  const [min, setMin] = useState('')

  const [loadingMAP, setLoadingMAP] = useState(false)
  const [loadingPLOT, setLoadingPLOT] = useState(false)

  const token = useSelector((state) => state.userLogin.userInfo.token);

  ////////////
  const { t, i18n } = useTranslation();  

  const redIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  useEffect(() => {
    const storedLanguage = localStorage.getItem('selectedLanguageAFS');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);
  ////////////

  useEffect(() => {

    const fetchData = async () => {

      try {

        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
        
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/get-mobile-phone-data/`, config);
        
        setDateoptions(response.data)

      } catch (error) {

      } finally {

        setLoading(false)

      }
      
    };

    fetchData(); 
  }, [token]);

  const handleSelectChange = async (e) => {
    const selectedGroupId = e.target.value;
    
    // Update the local state so the dropdown shows the selected item
    setDate(selectedGroupId);

    if (!selectedGroupId) return; // Do nothing if empty option selected

    try {
      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      };
      
      // Use the ID from the select value directly in the URL
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/sensors/get-mobile-phone-data/${selectedGroupId}/`, 
        config
      );
      
      setSensordata(response.data);
    } catch (error) {
      console.error("Error fetching group data:", error);
      setError(true);
      setMessage("Failed to fetch data for the selected date.");
    }
  };

  const [loadingdownload, setLoadingdownload] = useState(true)

  const download = async(e) => {
    setLoadingdownload(false)
  
    try {
        // Effettua la richiesta GET specificando il responseType 'blob'
        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_API}/sensors/download-mobile-data/${date}/`, // Assicurati che l'endpoint corrisponda a quello definito in Django
            {
            responseType: 'blob', // Importante per gestire dati binari (il file zip)
            headers: {
                // Se usi autenticazione JWT, ad esempio:
                Authorization: `Bearer ${token}`,
            },
            }
        );

        // Crea un oggetto Blob dall'array di byte ricevuto
        const blob = new Blob([response.data], { type: 'application/zip' });
        // Crea un URL temporaneo per il blob
        const url = window.URL.createObjectURL(blob);
        // Crea un elemento link per forzare il download
        const link = document.createElement('a');
        link.href = url;
        // Imposta il nome del file che verrà scaricato
        link.setAttribute('download', `acquisition_${date}.zip`);
        // Aggiungi il link al DOM e simula il click
        document.body.appendChild(link);
        link.click();
        // Pulizia: rimuovi il link e revoca l'URL creato
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Errore durante il download:', error);
    } finally {
        setLoadingdownload(true)
    }
  }

  return (
    <div>
      <Header/>
      <Container className="mt--15" fluid>
        <Row>
          <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="text-center mt-5">
            <Card>
              <CardHeader>
                  <h3>{t('Analysis Setting')}</h3>
              </CardHeader>
              <CardBody>
                <Form>
                    {error && <Alert  color="danger" fade={false}>{message}</Alert >}
                    <Form.Group controlId="exampleForm.SelectCustom">
                        <Form.Label>{t('Select the date')}</Form.Label>
                        <Form.Control 
                            as="select" 
                            onChange={handleSelectChange}
                            value={date} // This will now hold the group_acquisition ID
                        >
                            <option key={""} value={""}>
                                {t('Select a date...')}
                            </option>
                            {dateoptions.map((item, index) => (
                                <option key={index} value={item.group_acquisition}>
                                    {/* Formatting the first_timestamp from your console log */}
                                    {format(new Date(item.first_timestamp), 'PPpp')}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <br></br>
                    <Form.Group controlId="exampleForm.SelectCustom">
                        <Form.Label>{t('Select variable to map')}</Form.Label>
                        <Form.Control 
                            as="select"
                            value={variable}
                            onChange={(e) => setVariable(e.target.value)}>
                            <option value={"count"}>
                                {t('Count')}
                            </option>
                            <option value={"weight"}>
                                {t('Weight')}
                            </option>
                            <option value={"area"}>
                                {t('Area')}
                            </option>
                            <option value={"width"}>
                                {t('Width')}
                            </option>
                            <option value={"height"}>
                                {t('Height')}
                            </option>
                        </Form.Control>
                    </Form.Group>   
                </Form>           
            </CardBody>
            <CardFooter>
              <Row>
                {loadingsubmit ? (
                  <>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                      <Button color="success" onClick={""}>
                        {t('Create Map')} <i className="fa-solid fa-code"></i>
                      </Button>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                      <Button color="success" disabled>
                        <Spinner size="sm">
                          {t('Loading')}
                        </Spinner>
                        <span>
                          {' '}{t('Loading')}
                        </span>
                      </Button>
                    </Col>
                  </>
                )}
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                    <Link to="/">
                        <Button color='primary'>
                            {t('Go back')} <i className="fas fa-rotate-left"></i>
                        </Button>
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                  {loadingdownload ? (
                      <>
                        <Button 
                            color='success' 
                            onClick={download}>
                                {t('Download')}
                        </Button>
                    </>
                  ) : (
                      <>
                          <Button 
                              color='success' 
                              disabled>
                                  {t('Downloading')}
                                  <Spinner size={"sm"} />
                          </Button>
                      </>
                  )}
                </Col>
              </Row>
            </CardFooter>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8} className="text-center mt-5">
            {sensordata && sensordata.length>0 ? (
              <>
                <Card>
                  <CardHeader>
                    <h3>{t('Data Points Location')}</h3>
                  </CardHeader>
                  <CardBody>
                    <MapContainer key={sensordata[0].group_acquisition+sensordata[0].id} center={[sensordata[0].latitude, sensordata[0].longitude]} zoom={15} style={{ height: '500px', width: '100%', margin: 0, padding: 0 }}>
                      <LayersControl position="topright">
                        <LayersControl.BaseLayer checked name="OpenStreetMap">
                          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer checked name="Satellite">
                          <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" attribution='&copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community' />
                        </LayersControl.BaseLayer>
                      </LayersControl>
                      {sensordata.map((farmer, index) => (
                        <FeatureGroup key={index}>
                          <Marker position={[farmer.latitude, farmer.longitude]} icon={redIcon}>
                            <Popup>
                              <p>{t('Crop :')} {t(`translation:${farmer.crop}`)}</p>
                              <p>{t('Number of Grape :')} {farmer.count}</p>
                              <p>{t('Date Time of Data Acquisition :')} {format(new Date(farmer.timestamp), 'PPpp')}</p>
                              {farmer.photo1 ? <img src={farmer.photo1} alt="Photo 1" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }
                              {farmer.photo2 ? <img src={farmer.photo2} alt="Photo 2" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }
                            </Popup>
                          </Marker>
                        </FeatureGroup>
                      ))}
                    </MapContainer>
                  </CardBody>
                </Card>
              </>
            ):null}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default MobilePhoneInsurance
